import {
    apiRequest,
    pensiunskDetail,
    pensiunDocuments
} from "../../../../../services/adapters/kepegawaian/pensiunskService"

class DetailRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", pensiunskDetail, {
            params: query
        }, true)
    }

    fetchDocument = async (query) => {
        return await apiRequest("get", pensiunDocuments, {
            params: query
        }, true)
    }
}

export default DetailRepository